<template>
  <hi-card>
    <div class="p-4 flex flex-col gap-2">
      <div class="flex gap-4">
        <div>Active Accounts:</div>
        <div>{{ activeNumber }}</div>
      </div>
      <div class="flex gap-4">
        <div>Closed Accounts:</div>
        <div>{{ closedNumber }}</div>
      </div>
    </div>
  </hi-card>
</template>

<script>
import HiCard from "@/hive-vue3/components/HiCard";
import { computed } from "vue";
import {
  getAllActiveAccounts,
  getAllClosedAccounts,
} from "@/hive-vue3/modules/accounts/data";
export default {
  name: "BasicAccountNumCard",
  components: { HiCard },
  setup() {
    const activeNumber = computed(() => {
      const res = getAllActiveAccounts();
      return res.length;
    });
    const closedNumber = computed(() => {
      const res = getAllClosedAccounts();
      return res.length;
    });

    return {
      activeNumber,
      closedNumber,
    };
  },
};
</script>

<style scoped></style>
